import { Injectable, signal } from '@angular/core';
import { ApiService } from '../api.service';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  private readonly featureFlags = signal<Record<string, boolean>>({});

  constructor(private readonly apiService: ApiService) { }

  getAllFeatureFlags(): void {
    this.apiService.get<Record<string, boolean>>(environment.featureFlag.getAll)
      .pipe(map((response: any) => response.data))
      .subscribe({
        next: flags => this.featureFlags.set(flags)
      });
  }

  isFeatureFlagEnabled(flag: string): boolean {
    const flags = this.featureFlags();
    return flags[flag] === true;
  }

  getFeatureFlags(): Record<string, boolean> {
    return this.featureFlags();
  }

  refreshFeatureFlags() {
    this.apiService.post(environment.featureFlag.refresh).subscribe({
      next: () => this.getAllFeatureFlags()
    })
  }

  updateFeatureFlags(flags: Record<string, boolean>): Observable<any> {
    return this.apiService.put(environment.featureFlag.update, flags);
  }

}
